import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

interface Option {
  id: string;
  name: string;
}

@Component({
  selector: 'fc-custom-select',
  templateUrl: './fc-custom-select.component.html',
  styleUrls: ['./fc-custom-select.component.scss']
})
export class FcCustomSelectComponent implements OnInit, OnChanges {

  @Input()
  public label: string;

  @Input()
  public options: Option[];

  @Input()
  public selectedOption: Option;

  @Output() selectedOptionOutput: EventEmitter<any> = new EventEmitter();
  @Output() editOptionOutput: EventEmitter<any> = new EventEmitter();
  @Output() addOptionOutput: EventEmitter<any> = new EventEmitter();

  public search = '';
  public displayOptions = false;

  constructor(
    private eRef: ElementRef,
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnInit(): void {
    if (!this.label) { return; }
    this.label = this.label.toLowerCase();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedOption && (changes.selectedOption.currentValue !== changes.selectedOption.previousValue)) {
      this.selectOption(changes.selectedOption.currentValue, true);
    }
  }

  selectOption(option: Option, firstRun: boolean = false): void {
    if (this.selectedOption === option && !firstRun) {
      return;
    }
    this.selectedOption = option;
    this.selectedOptionOutput.emit(option);
  }

  editOption(event: Event, option: Option): void {
    event.stopPropagation();
    this.editOptionOutput.emit(option);
  }

  addOption(event: Event): void {
    event.stopPropagation();
    this.addOptionOutput.emit();
  }

  get filteredOptions(): Option[] {
    if (!this.search) { return this.options; }
    return this.options.filter((option) => option.name.toLowerCase().includes(this.search.toLowerCase()));
  }

  @HostListener('document:click', ['$event'])
  clickout(event): void {
    if (!this.eRef.nativeElement.contains(event.target) && this.displayOptions) {
      this.displayOptions = false;
    }
  }
}
